import React, { Component } from 'react';
import './customselect.css';

class FachgebieteSelect extends Component
{

    constructor(props) {
        super(props);
        this.state = { fachgebieteDropdown: false}
    }
    showFachgebieteDropdown() {
        this.setState({ fachgebieteDropdown: true });
        this.props.selectFachgebiet('101,102,103,104,105,106,107,110,111,112,113,116,21,115')
    }

    hideFachgebieteDropdown() {
        this.setState({ fachgebieteDropdown: false });
        this.props.selectFachgebiet(108);
    }

    render() {

        console.log(this.props.selected);
        var title = 'Angebote zur';
        if (this.props.selected == 108) {
            title += ' Agrarbildung';
        } else if (this.props.selected != '') {
            title += ' Landbildung';
        }

        console.log(this.fachgebieteDropdown)
        if (this.state.fachgebieteDropdown == false) {
            return <div className={'form-group'}>
                <label>{ title }:</label>
                <div>
                    <button className={'btn btn-success mr-2'} style={{width: 'auto'}} onClick={ this.showFachgebieteDropdown.bind(this) }>Landbildung</button>
                    <button className={'btn btn-success'} style={{width: 'auto'}} onClick={ this.hideFachgebieteDropdown.bind(this) }>Agrarbildung</button>
                </div>
            </div>
        }

        return <div className={'row'}>
            <div className={'col-6'}>
                <div className={'form-group'}>
                    <label>{ title }:</label>
                    <div>
                        <button className={'btn btn-success mr-2'} style={{width: 'auto'}} onClick={ this.showFachgebieteDropdown.bind(this) }>Landbildung</button>
                        <button className={'btn btn-success'} style={{width: 'auto'}} onClick={ this.hideFachgebieteDropdown.bind(this) }>Agrarbildung</button>
                    </div>
                </div>
            </div>
            <div className={'col-6'}>
                <div className={'form-group'}>
                    <label>Fachgebiet</label>
                        <select className={'form-control custom-select'} id={'Fachgebiet'} value={this.props.selected} ref={'fachgebieteSelect'} onChange={ ()=>this.props.selectFachgebiet(this.refs.fachgebieteSelect.value) }>
                        <option value={"null"}>Alle Fachgebiete</option>
                        <option key={'101,102,103,104,110,113'} value={'101,102,103,104,110,113'}>Gesellschaft und Politik</option>
                        <option key={'111'} value={'111'}>Gesundheit und Prävention</option>
                        <option key={'112'} value={'112'}>Ernährung und Hauswirtschaft</option>
                        <option key={'116,115'} value={'116,115'}>Beruf und Arbeit</option>
                        <option key={'105'} value={'105'}>Kultur und Kreativität</option>
                        <option key={'106,107'} value={'106,107'}>Technik und Medien</option>
                        <option key={'21'} value={'21'}>Feste und Geselligkeit</option>
                    </select>
                </div>
            </div>
        </div>
    }
}

/*
* <option key={'108'} value={'108'}>Landwirtschaft und Umwelt</option>
* */

export default FachgebieteSelect




// WEBPACK FOOTER //
// ./src/components/FachgebieteSelect.js